import React from 'react';
import './SelectTraining.css';
import '../App.css';
import { withNavigation } from '../Components/helpers/withNavigation';
import {v4 as uuid} from 'uuid';
import { Button } from "reactstrap";
import { TourProvider } from '@reactour/tour';
import { TourBridge, SkipHiddenTourSteps } from '../utils/TourHelpers';

function SelectTrainingWithTour(props){
  const steps= [
    {
      selector:'.app-introduction',
      content:(
        <>
          <ul>
            <li>
              To make a training, select each of the tabs and answer the questions or follow the directions.
              At the end, the app will automatically put together the training based on your responses.
            </li>

            <li>
              At each step, you may have the opportunity to:
              <ul>
                <li>Type text in the box provided</li>
                <li>Record a short audio narration to explain the text</li>
                <li>Add a video to demonstrate</li>
                <li>Add a photo to illustrate</li>
              </ul>
            </li>

            <li>Edit by swiping first left (on a tablet), right clicking (on a PC), or control + click (on Mac) to reveal options.</li>
            <li>The training will be auto-saved as you go along.</li>
            <li>If you need help at any point, click on <strong>HELP</strong>.</li>
            {/* <li>
              <a href="#" target="_blank">
                Click here to view a video demonstrating how to make a training using INSTRUCT.
              </a>
            </li> */}
          </ul>
        </>
      )
    },
    {
      selector:'.function-bar',
      content:(
        <>
          <ul>
            {!props.evalMode && (
              <li>
                UI: Accordion or UI: Step-by-Step switch between two different user interfaces for create trainings
                <ul>
                  <li>If you are new to INSTRUCT, use the Accordion interface to create a training.</li>
                  <li>If you have experience creating INSTRUCT trainings, you may prefer the Step by Step interface.</li>
                  <li>The created training will look the same with both approaches.</li>
                </ul>
              </li>
            )}
            <li>Import Training to load a training from a JSON or zip file</li>
            <li>Help to show this tour again.</li>
          </ul>
        </>
      ),
    },
    {
      selector: '.training-list',
      content: (
        <>
          <ul>
            <li>This is your list of trainings.</li>
            <li>Tap, or click, on a training to open it.</li>
            <li>
              Swiping left, right clicking, control + click (on mac) on a training to see more options like Edit, Delete, and Export.
              <ul>
                <li><strong>Edit</strong> reopens the creation interface for you to continue editing your training.</li>
                <li><strong>Delete</strong> removes the training from your device. We recommend exporting before deleting in case you want your content back.</li>
                <li><strong>Export</strong> creates and downloads a zip file that can be sent to other devices so others can access the training you created.</li>
              </ul>
            </li>
          </ul>
        </>
      ),
    },{
      selector: '.create-training',
      content: (
        <>
          <ul>
            <li>Tap, or click, here to create a new training.</li>
          </ul>
        </>
      ),
    }
  ]
  return (
    <div className={'training-container'}>
      <TourProvider 
        steps={steps} 
        showBadge={false}
        padding={10} 
        scrollSmooth 
        className="my-custom-tour" 
        onClickClose={() => {props.updateState({showTour: false});}} 
        onClickMask={() => {props.updateState({showTour: false});}} 
      >
        <SkipHiddenTourSteps/>
        <TourBridge showTour={props.showTour} incognitoBrowser={props.incognitoBrowser} updateState={props.updateState}>
          <SelectTraining {...props} />
        </TourBridge>
      </TourProvider>
    </div>
  );
}

class SelectTraining extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      swipedId: null,
      draggingId: null,
      dragStartX: null,
      dragStartSwipedId: null,
      dragHoldStartTime: null,
    };
  }

  componentDidMount() {
    // Add delegation listeners to catch events from all items, even those outside viewport
    document.addEventListener('pointerdown', this.handleDelegatedPointerDown, true);
    document.addEventListener('pointermove', this.handleDelegatedPointerMove, true);
    document.addEventListener('pointerup', this.handleDelegatedPointerUp, true);
  }

  componentWillUnmount() {
    document.removeEventListener('pointerdown', this.handleDelegatedPointerDown, true);
    document.removeEventListener('pointermove', this.handleDelegatedPointerMove, true);
    document.removeEventListener('pointerup', this.handleDelegatedPointerUp, true);
  }

  handleDelegatedPointerDown = (e) => {
    const item = e.target.closest('.training-item');
    if (!item) return;
    
    const id = this.getItemIdFromElement(item);
    if (!id) return;
    
    this.handleTouchStart(id, e);
  }

  handleDelegatedPointerMove = (e) => {
    const item = e.target.closest('.training-item');
    if (!item) return;
    
    const id = this.getItemIdFromElement(item);
    if (!id) return;
    
    this.handleTouchMove(id, e);
  }

  handleDelegatedPointerUp = (e) => {
    const item = e.target.closest('.training-item');
    // if (!item) return;
    
    const id = item ? this.getItemIdFromElement(item) : null;
    // if (!id) return;
    
    const training = id ? this.props.trainings.find(t => t.Id === id) : null;
    if (training) {
      this.handleTouchEnd(training, e);
    }
  }

  getItemIdFromElement = (element) => {
    // Extract the training ID from the training-item element
    const text = element.querySelector('.training-content')?.textContent;
    if (!text) return null;
    
    const training = this.props.trainings.find(t => t.Title === text.trim());
    return training?.Id || null;
  }

  handleTouchStart = (Id, e) => {
    // console.log("Touch start on item:", Id, " event:", e);
    if(this.state.reordering){ return;}
    
    // Capture pointer to ensure events continue to fire even during scroll
    if (e.type === "pointerdown" && e.target.setPointerCapture) {
      try {
        e.target.setPointerCapture(e.pointerId);
      } catch (err) {
        console.warn("setPointerCapture failed:", err);
      }
    }
    
    const startX = e.clientX || (e.touches && e.touches[0]?.clientX);
    
    if ((e.type === "touchstart" || e.type === "pointerdown") && (e.touches?.length === 1 || e.isPrimary)) {
      this.setState({
        dragStartX: startX,
        draggingId: Id,
        dragStartSwipedId: this.state.swipedId,
        dragHoldStartTime: Date.now(),
      });
    } else if (e.type === "mousedown" && e.button === 0) {
      this.setState({
        dragStartX: e.clientX,
        draggingId: Id,
        dragStartSwipedId: this.state.swipedId,
        dragHoldStartTime: Date.now(),
      });
    }
  };

  handleTouchMove = (Id, e) => {
    if (this.state.draggingId) {
      const currentX = e.clientX ?? (e.touches && e.touches[0]?.clientX);
      const deltaX = currentX - this.state.dragStartX;
      // Detect horizontal drag for swipe
      const item = e.target.closest('.training-item');
      const width = item ? item.offsetWidth : window.innerWidth;
      if(Math.abs(deltaX) > width / 10) {
        if (deltaX < 0 && !this.state.swipedId)
          this.setState({ swipedId: this.state.draggingId });
        if(deltaX > 0 && this.state.swipedId) 
          this.setState({ swipedId: null });
      }else{
        this.setState({ swipedId: this.state.dragStartSwipedId });
      }
    }
  }

  handleTouchEnd = (training, e) => {
    // Release pointer capture
    if (e.type === "pointerup" && e.target.releasePointerCapture) {
      try {
        e.target.releasePointerCapture(e.pointerId);
      } catch (err) {
        console.warn("releasePointerCapture failed:", err);
      }
    }
    
    this.setState({
      dragStartX: null,
      draggingId: null,
      dragStartSwipedId: null
    });
    // if held less than 250ms, treat as a tap
    if(!this.state.swipedId && Date.now() - this.state.dragHoldStartTime < 250){
      this.handleOpen(training);
    }
  }

  handleOpen = (training) => {
    this.props.updateState({ currentTraining: training, currentStep: null }, () => {
      console.log('Opened training:', training.Title);
      const curURL = new URL(window.location.href);
      this.props.navigate({
        pathname: '/perform-training',
        search: curURL.search
      });
    });
  };

  handleExport = async (training) => {
    var dataStr = "data:text/json;charset=utf-8,\n\"Training\":" + encodeURIComponent(JSON.stringify(training, null, 2));
    dataStr += "\n\"Media Files\":";
    var mediaFiles = await this.props.getMediaForTraining(training.Id);
    // Add media files as JSON, but also export each file as a Blob in a zip
    dataStr += JSON.stringify(mediaFiles, null, 2);

    // Export as a zip with JSON and media files
    if (mediaFiles && mediaFiles.length > 0) {
      // Dynamically import JSZip only when needed
      const JSZip = (await import('jszip')).default;
      const zip = new JSZip();

      // Add the JSON export
      const exportJson = {
        Training: training,
        "Media Files": mediaFiles.map(f => {
          // Exclude the actual blob from the JSON, just keep metadata
          const { file, ...meta } = f;
          return meta;
        })
      };
      zip.file(`${training.Title.replace(/\s+/g, '_')}_export.json`, JSON.stringify(exportJson, null, 2));

      // Add each media file as a blob
      for (const fileObj of mediaFiles) {
        if (fileObj.file && fileObj.id) {
          zip.file(fileObj.id, fileObj.file);
        }
      }

      // Generate and download the zip
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const zipAnchor = document.createElement('a');
      zipAnchor.href = URL.createObjectURL(zipBlob);
      zipAnchor.download = `${training.Title.replace(/\s+/g, '_')}_export.zip`;
      document.body.appendChild(zipAnchor);
      zipAnchor.click();
      zipAnchor.remove();
      this.setState({ swipedId: null });
      console.log('Exported training and media as zip:', training.Title);
      return;
    }
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", `${training.Title.replace(/\s+/g, '_')}_export.json`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
    this.setState({ swipedId: null });
    console.log('Exported training:', training.Title);
  };

  handleEdit = (training) => {
    this.props.updateState({ currentTraining: training, currentStep: null }, () => {
      console.log('Editing training:', training.Title);
      const curURL = new URL(window.location.href);
      if(this.props.uiInUse === 'UI: Accordion')
        this.props.navigate({
          pathname: '/main-accordion',
          search: curURL.search
        });
      else
        this.props.navigate({
          pathname: '/create-checklist',
          search: curURL.search
        });
    });
    this.setState({ swipedId: null });
  };

  handleDelete = (training) => {
    if (window.confirm(`Are you sure you want to delete training: ${training.Title}?`)) {
      this.props.updateState((prev) => ({
        trainings: prev.trainings.filter(t => t.Id !== training.Id)
      }));
      this.setState({ swipedId: null });
    }
  };

  handleCreate = () => {
    const newId = this.props.trainings.length ? Math.max(...this.props.trainings.map(t => t.id)) + 1 : 1;
    const newTitle = prompt("Enter the title for your new Training:", `New Training ${newId}`);
    if (!newTitle) return; // Cancelled or empty Title
    if (newTitle.trim() === "") {
      alert("Title cannot be empty.");
      return;
    }

    const newTraining = { 
      id: newId, 
      Id: uuid(), 
      Title: newTitle,
      CheckListIterations: 1,
      CommunciationPartners: '',
      SubjectPersona: '',
      FinalizedTime: null,
      Steps: [],
      CheckList: []
    };
    this.props.updateState((prev) => ({
      trainings: [...prev.trainings, newTraining],
      currentTraining: newTraining,
      currentStep: null
    }), () => {
      console.log('Created new training:', newTraining.Title);
        const curURL = new URL(window.location.href);
      if(this.props.uiInUse === 'UI: Accordion')
        this.props.navigate({
          pathname: '/main-accordion',
          search: curURL.search
        });
      else
        this.props.navigate({
          pathname: '/create-checklist',
          search: curURL.search
        });
    });
  };

  render() {
    console.log("rendering SelectTraining, with props: ",this.props, " state: ", this.state);
    const {
      trainings
    } = this.props;

    const { swipedId } = this.state;

    return (
      <div style={{overflow: 'auto'}}>
        <div className='app-introduction' style={{ margin: '20px', textAlign: 'left', fontSize:'.75em' }}>
          <p>
          People who need or use AAC interact with many different communication partners,
          including family, friends, members of the community, and professionals.
          These partners may need training to ensure successful interactions.
          </p>

          <ul>
          <li>Professionals, families, or people who use AAC can use INSTRUCT to create short trainings for communication partners or edit existing trainings.</li>
          <li>Communication partners can use INSTRUCT to view trainings to learn new strategies or skills.</li>
          </ul>

          <p>
          Visit the AAC Learning Center to see <a href="https://aac-learning-center.org/category/instruct-video" target="_blank" rel="noreferrer">a library of INSTRUCT trainings</a>.
          </p>
          <p>
          Click the Help button in the function bar for instructions and a tour of the INSTRUCT app.
          </p>
          <p>
          When creating a training, edit by first swiping left (on a tablet), right-clicking (on a PC), or control + click (on Mac) to reveal options.
          The training will be auto-saved as you go along.
          </p>
        </div>
        <div className="training-list">
          {trainings.map(training => (
            <div
              key={training.Id}
              className={`training-item ${swipedId === training.Id ? 'swiped' : ''}`}
              onContextMenu={(e) => {
                    e.preventDefault(); // prevent default right-click menu
                    if (training.Id === this.state.swipedId) {
                      this.setState({ swipedId: null });
                    } else {
                      this.setState({ swipedId: training.Id });
                    }
                  }}
              >
                  <div className="training-content">{training.Title}</div>
                  {swipedId === training.Id && (
                    <div className="training-actions">
                      <Button color='success' onClick={(e) => { e.stopPropagation(); this.handleEdit(training); }}>Edit</Button>
                      <Button color='danger' onClick={(e) => { e.stopPropagation(); this.handleDelete(training); }}>Delete</Button>
                      <Button color='primary' onClick={(e) => { e.stopPropagation(); this.handleExport(training); }}>Export</Button>
                    </div>
                  )}
              </div>
            ))}
          </div>
          <div className="create-training" onClick={this.handleCreate}>
            + Create Training
          </div>
        </div>  
    );
  }
}

export default withNavigation(SelectTrainingWithTour);
